import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  HomeIcon, 
  UsersIcon, 
  UserGroupIcon, 
  BuildingOfficeIcon,
  CogIcon,
  UserCircleIcon
} from '@heroicons/react/24/outline';

const AdminSidebar: React.FC = () => {
  const location = useLocation();

  const navigationItems = [
    { name: 'Dashboard', href: '/dashboard', icon: HomeIcon },
    { name: 'User Management', href: '/users', icon: UsersIcon },
    { name: 'Candidates', href: '/candidates', icon: UserGroupIcon },
    { name: 'Employers', href: '/employers', icon: BuildingOfficeIcon },
    { name: 'Admin Profile', href: '/admin-settings', icon: UserCircleIcon },
    { name: 'System Settings', href: '/settings', icon: CogIcon },
  ];

  return (
    <div className="w-64 bg-white dark:bg-gray-800 shadow-lg relative flex flex-col h-full">
      {/* Header */}
      <div className="flex items-center justify-center h-16 border-b border-gray-200 dark:border-gray-700 flex-shrink-0">
        <div className="flex items-center space-x-2">
          <div className="w-8 h-8 bg-admin-600 rounded-lg flex items-center justify-center">
            <span className="text-white font-bold text-sm">IJ</span>
          </div>
          <span className="text-xl font-bold text-gray-900 dark:text-white">
            Admin Panel
          </span>
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 mt-8 px-4 overflow-y-auto">
        <ul className="space-y-2">
          {navigationItems.map((item) => {
            const isActive = location.pathname === item.href;
            return (
              <li key={item.name}>
                <Link
                  to={item.href}
                  className={`sidebar-link ${isActive ? 'active' : ''}`}
                >
                  <item.icon className="w-5 h-5 mr-3" />
                  {item.name}
                </Link>
              </li>
            );
          })}
        </ul>
      </nav>

      {/* Footer */}
      <div className="p-4 flex-shrink-0">
        <div className="bg-admin-50 dark:bg-admin-900/20 rounded-lg p-4">
          <p className="text-sm text-admin-700 dark:text-admin-300 font-medium">
            ImmediateJoiner
          </p>
          <p className="text-xs text-admin-600 dark:text-admin-400">
            Admin Dashboard v1.0
          </p>
        </div>
      </div>
    </div>
  );
};

export default AdminSidebar;